import React from 'react';
import {
  AppBar as MuiAppBar,
  Toolbar,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Switch
} from '@mui/material';

const AdminAppBarUnauthenticated = ({ toggleDarkMode, darkMode }) => {

  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));


  return (
    <>
      <MuiAppBar position="static" elevation={1}>
        <Toolbar sx={{ 
          minHeight: '64px',
          justifyContent: 'space-between',
          px: { xs: 1, sm: 2, md: 3 }
        }}>
          {/* Logo */}
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
              fontWeight: 'bold',
              letterSpacing: '0.5px',
              mr: { md: 2, lg: 4 }
            }}
          >
            UnioFunds Admin
          </Typography>
              <Box sx={{
                display: 'flex',
                flexGrow: 1,
                justifyContent: 'center',
                gap: 1,
                '& .MuiButton-root': {
                  fontSize: { md: '0.8rem', lg: '0.9rem' },
                  px: { md: 1, lg: 2 },
                  textTransform: 'none',
                  fontWeight: 'medium',
                  minWidth: 'fit-content'
                }
              }}>     
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Switch
                  checked={darkMode}
                  onChange={toggleDarkMode}
                  color="secondary"
                  size={isTablet ? 'small' : 'medium'}
                  inputProps={{ 'aria-label': 'toggle dark mode' }}
                />  
              </Box>
        </Toolbar>
      </MuiAppBar>
    </>
  );
};

export default AdminAppBarUnauthenticated;